import React, { useState } from 'react';
import { api } from '../services/api';
import '../styles/Login.css';

// Composant de connexion/inscription
function Login({ setToken }) {
  // Etat : true = connexion, false = inscription
  const [isLogin, setIsLogin] = useState(true);
  // Champs du formulaire
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  // Liste des erreurs de validation du mot de passe
  const [passwordErrors, setPasswordErrors] = useState([]);

  // Vérifie les règles du mot de passe et retourne les erreurs
  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8) {
      errors.push("Au moins 8 caractères");
    }
    if (!/[a-z]/.test(password)) {
      errors.push("Au moins une minuscule");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("Au moins une majuscule");
    }
    if (!/[0-9]/.test(password)) {
      errors.push("Au moins un chiffre");
    }
    return errors;
  };

  // Met à jour le mot de passe et affiche les erreurs en temps réel
  const handlePasswordChange = (e) => {
    const newPass = e.target.value;
    setPass(newPass);
    // Vérification seulement en mode inscription
    if (!isLogin && newPass.length > 0) {
      setPasswordErrors(validatePassword(newPass));
    } else {
      setPasswordErrors([]);
    }
  };

  // Soumission du formulaire (connexion ou inscription)
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation du mot de passe uniquement pour l'inscription
    if (!isLogin) {
      const errors = validatePassword(pass);
      if (errors.length > 0) {
        alert("Mot de passe invalide : " + errors.join(", "));
        return;
      }
    }
    
    try {
      if (isLogin) {
        // Connexion : on récupère et stocke le token
        const res = await api.login(email, pass);
        localStorage.setItem('user_token', res.data.token);
        setToken(res.data.token);
      } else {
        // Inscription : on crée le compte puis on bascule en mode connexion
        await api.register(email, pass);
        alert("Compte créé ! Connectez-vous.");
        setIsLogin(true);
        setPass('');
        setPasswordErrors([]);
      }
    } catch (e) { alert("Erreur identifiants"); }
  };

  return (
    <div className="login-page-wrapper">
      <div className="box">
        <h1>{isLogin ? 'Connexion' : 'Inscription'}</h1>
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} required />
          <input type="password" placeholder="Mot de passe" value={pass} onChange={handlePasswordChange} required />
          {!isLogin && (
            <div className="password-requirements">
              <small style={{color: '#6b7280', display: 'block', marginBottom: '8px'}}>Le mot de passe doit contenir :</small>
              <ul style={{margin: 0, paddingLeft: '20px', fontSize: '13px'}}>
                <li style={{color: pass.length >= 8 ? '#10b981' : '#ef4444'}}>
                  {pass.length >= 8 ? '✓' : '✗'} Au moins 8 caractères
                </li>
                <li style={{color: /[a-z]/.test(pass) ? '#10b981' : '#ef4444'}}>
                  {/[a-z]/.test(pass) ? '✓' : '✗'} Une minuscule
                </li>
                <li style={{color: /[A-Z]/.test(pass) ? '#10b981' : '#ef4444'}}>
                  {/[A-Z]/.test(pass) ? '✓' : '✗'} Une majuscule
                </li>
                <li style={{color: /[0-9]/.test(pass) ? '#10b981' : '#ef4444'}}>
                  {/[0-9]/.test(pass) ? '✓' : '✗'} Un chiffre
                </li>
              </ul>
            </div>
          )}
          <button type="submit">{isLogin ? 'Connectez-vous' : "Inscrivez-vous"}</button>
        </form>
        <button className="link-btn" onClick={() => setIsLogin(!isLogin)}>
          {isLogin ? "Pas de compte ?" : "Vous avez déjà un compte"}
        </button>
      </div>
    </div>
  );
}

export default Login;